import { baseState } from '@/states/store'
import { getCookie } from './cookie'
const { UMI_ENV } = process.env

export const isOEM = () => {
  return !!baseState.userInfo.oemFlag
}

export const redirectToOem = () => {
  const bosId = getCookie('saasBosId')
  const key = getCookie('saasKey')
  //window.location.origin
  window.location.href = (UMI_ENV !== 'online'?'https://master.saas.weimobqa.com':'https://master.weimob.com') + `/bos/products/aigpt/${bosId}/${key}/aiwriting/workspace?type=0`
}